/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PackageDetailedResponse } from '../../models/package-detailed-response';

export interface GetPackageById$Params {
  packageId: string;
}

export function getPackageById(http: HttpClient, rootUrl: string, params: GetPackageById$Params, context?: HttpContext): Observable<StrictHttpResponse<PackageDetailedResponse>> {
  const rb = new RequestBuilder(rootUrl, getPackageById.PATH, 'get');
  if (params) {
    rb.path('packageId', params.packageId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PackageDetailedResponse>;
    })
  );
}

getPackageById.PATH = '/packages/{packageId}';
